import { defineComponent } from 'vue';
import { panelProps } from './interface';
/** Marker component — real rendering happens in Splitter. */
const Panel = defineComponent({
    name: 'ASplitterPanel',
    inheritAttrs: false,
    props: panelProps(),
    setup(_, { slots }) {
        return () => { var _a; return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots); };
    },
});
export default Panel;
